"use client"

// src/components/skeleton.ts
var Skeleton = {
  baseStyle: {
    background: ["blackAlpha.300", "whiteAlpha.300"],
    borderColor: ["blackAlpha.400", "whiteAlpha.400"],
    borderRadius: "sm",
    opacity: 0.7
  },
  defaultProps: {
    endColor: ["blackAlpha.400", "whiteAlpha.400"],
    startColor: ["blackAlpha.300", "whiteAlpha.300"]
  }
};

export {
  Skeleton
};
//# sourceMappingURL=chunk-6JVYL5L2.mjs.map